// Owner: account-settings (plan §9.3). Account › Notifications.
import { createFileRoute } from '@tanstack/react-router';
import { NotificationsPage } from '../../../features/account/NotificationsPage';

export const Route = createFileRoute('/_settings/account/notifications')({
  component: NotificationsPage,
});
